import { InterviewRecordingManager } from '@/services/recording'
import { logger } from '@/lib/logging'
import type { SessionRefs } from './types'

interface StartRecordingArgs {
  refs: SessionRefs
  interviewId: string
  apiBaseUrl: string
}

export function startRecording({ refs, interviewId, apiBaseUrl }: StartRecordingArgs) {
  if (!refs.mediaStreamRef.current || !refs.serviceRef.current) return

  try {
    if (!refs.recordingManagerRef.current) {
      refs.recordingManagerRef.current = new InterviewRecordingManager({
        microphoneStream: refs.mediaStreamRef.current,
        aiAudioService: refs.serviceRef.current,
        interviewId,
        apiBaseUrl,
      })
    } else {
      refs.recordingManagerRef.current.updateMicrophoneStream(refs.mediaStreamRef.current)
      refs.recordingManagerRef.current.updateAIAudioService(refs.serviceRef.current)
    }

    refs.recordingManagerRef.current.startRecording(refs.mediaStreamRef.current, true)
  } catch (err) {
    logger.error('Failed to start recording', { error: String(err) })
    startRecordingFallback(refs)
  }
}

function startRecordingFallback(refs: SessionRefs) {
  try {
    if (!refs.mediaStreamRef.current || !refs.recordingManagerRef.current) return

    refs.recordingManagerRef.current.startRecording(refs.mediaStreamRef.current, false)
    logger.warn('Recording started without AI audio (fallback)')
  } catch (err) {
    logger.error('Failed to start recording (fallback)', { error: String(err) })
  }
}
